<template>
    <div aria-label="Loading..." aria-live="polite" class="skeleton-loader my-2" role="alert">
        <div class="skeleton-loader__bone loading-ripple" />
    </div>
</template>
